import { FiEye, FiHeart, FiMessageCircle, FiShare2, FiExternalLink } from 'react-icons/fi';
import PlatformBadge from '../PlatformBadge/PlatformBadge';
import { formatNumber } from '../StatBlock/StatBlock';
import './UploadCard.css';

const formatDate = (iso) => {
  const d = new Date(iso);
  return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
};

const UploadCard = ({ upload, platform }) => {
  return (
    <div className="upload-card">
      <div className="upload-card-thumb">
        <PlatformBadge platform={platform} size="md" />
      </div>
      <div className="upload-card-body">
        <div className="upload-card-header">
          <h4 className="upload-card-title">{upload.title}</h4>
          {upload.url && upload.url !== '#' && (
            <a
              className="upload-card-external"
              href={upload.url}
              target="_blank"
              rel="noreferrer"
              title="Open on platform"
            >
              <FiExternalLink />
            </a>
          )}
        </div>
        <div className="upload-card-date">Published {formatDate(upload.publishedAt)}</div>
        <div className="upload-card-stats">
          <span className="upload-stat" title="Views">
            <FiEye /> {formatNumber(upload.stats.views)}
          </span>
          <span className="upload-stat" title="Likes">
            <FiHeart /> {formatNumber(upload.stats.likes)}
          </span>
          <span className="upload-stat" title="Comments">
            <FiMessageCircle /> {formatNumber(upload.stats.comments)}
          </span>
          <span className="upload-stat" title="Shares">
            <FiShare2 /> {formatNumber(upload.stats.shares)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default UploadCard;
